module.exports = __webpack_public_path__ + "static/media/arrowNext.84672fd6.svg";